import {apiUrl} from '../../context/context';
import {acerillAuthenticatedAxios} from './acerill-axios-instances';

const baseUrl = `${apiUrl}/recaptcha/v1`;

const findKeyPairs = () => {
  return acerillAuthenticatedAxios
    .get(baseUrl + '/key-pairs')
    .then(response => response.data);
};

const recaptchaV1Client = {
  findKeyPairs,
};
export default recaptchaV1Client;
